import React from 'react';
import classNames from 'classnames';
import {SVGIcon} from '@homeaway/react-svg';
import {MAIL__24} from '@homeaway/svg-defs/lib/defs/MAIL__24';

import './Inbox.less';

export class Inbox extends React.Component {
    get className() {
        return classNames(
            'site-header-inbox',
            {[`${this.props.cssClass}`]: !!this.props.cssClass},
        );
    }

    renderMessageCount = () => (!!this.props.unreadMessageCount && (
        <div className="site-header-inbox__unread-badge site-header-inbox__unread-badge--animated badge bg-brand">
            <div className="site-header-inbox__unread-badge-count">{this.props.unreadMessageCount}</div>
        </div>
    ))


    render() {
        // TODO: a11y this needs sr-only text explaing what the link is
        return (
            <div className={this.className}>
                <SVGIcon className="site-header-inbox__icon" inline markup={MAIL__24} />
                {this.renderMessageCount()}
            </div>
        );
    }
}
